import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link } from "react-router-dom";

const AddTeam = () => {
  const [formData, setFormData] = useState({
    name: "",
    position: "",
    paragraph: "",
    image: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, image: file });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create a FormData object to send the data
    const data = new FormData();
    data.append("name", formData.name);
    data.append("paragraph", formData.paragraph);
    data.append("image", formData.image);
    data.append("position", formData.position);

    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const url = "https://api.mbasolutions.co/api/team/upload";
      const response = await axios.post(url, data, config);

      // Show a success message using SweetAlert2
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Data added successfully",
      });

      // Reset the form fields to their initial values
      setFormData({
        name: "", // Reset to the default value
        paragraph: "",
        image: null,
      });

    } catch (error) {
      // Handle errors, e.g., display an error message
      console.error("Error adding data:", error);

      // Show an error message using SweetAlert2
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error adding data",
      });
    }
  };

  return (
    <>

      <div className="mx-auto w-full overflow-x-hidden">
       
        <form
          onSubmit={handleSubmit}
          className="w-full flex flex-col justify-center"
        >
          <div className="md:mx-auto">
            <label
              htmlFor="name"
              className="block text-[20px] py-4 font-semibold"
            >
              {" "}
              Name
            </label>
            <input
              name="name"
              id="name"
              onChange={handleInputChange}
              value={formData.name}
              className="rounded-md h-12 px-1 w-full md:w-[570px] border hover:outline-purple-500"
            />
          </div>
          <div className="md:mx-auto">
            <label
              htmlFor="position"
              className="block  text-[20px] py-4 font-semibold"
            >
              {" "}
              Position
            </label>
            <input
              name="position"
              id="position"
              onChange={handleInputChange}
              value={formData.postion}
              className="rounded-md h-12 px-1 w-full md:w-[570px] border hover:outline-purple-500"
            />
          </div>
          <div className="mx-auto">
            <label
              htmlFor="paragraph"
              className="block text-[20px] pt-5 py-4 font-semibold"
            >
              About the Personality(5 to 6 words):
            </label>
            <textarea
              name="paragraph"
              id="paragraph"
              onChange={handleInputChange}
              value={formData.paragraph}
              className=" md:w-[570px] h-28 w-full px-1 mx-auto rounded-md  border hover:outline-purple-500"
            />
          </div>
          <div className="mx-auto w-full md:w-[570px] mt-12">
            <label
              htmlFor="image"
              className="block text-[20px] py-4 font-semibold"
            >
              Choose Image:
            </label>

            <input
              type="file"
              name="image"
              id="image"
              onChange={handleImageChange}
              className="  outline-none h-10 m-2  text-md text-center "
            />
            <br />
          </div>
          <div>
            <button
              type="submit"
              className="block text-[20px] p-2 my-4 bg-purple-500 text-white hover:bg-purple-700 rounded-md mx-auto  "
            >
              Add Data
            </button>
          </div>
        </form>
       
      </div>
    </>
  );
};

export default AddTeam;
